module.exports = __webpack_public_path__ + "static/media/EliteLogo.0fd9058d.svg";